import { Box, Skeleton, Stack } from '@mantine/core';

export function SkeletonTable() {
  return (
    <Box
      sx={theme => ({
        borderBottom: `1px solid ${theme.colors.gray[1]}`,
      })}
    >
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
    </Box>
  );
}

function SkeletonRow() {
  return (
    <Stack
      spacing="02"
      sx={theme => ({
        borderTop: `1px solid ${theme.colors.gray[1]}`,
        padding: `${theme.spacing['04']} 0`,
        paddingLeft: theme.spacing['02'],
      })}
    >
      <Skeleton height={6} width={200} radius="xl" />
      <Skeleton height={6} width={100} radius="xl" />
    </Stack>
  );
}
